import React from "react";
import { Link } from "react-router-dom";

// UI Components
import { Settings, User } from "react-feather";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import logo from "../../assets/img/brands/mb-square-logo.png";

const NavBarAccountDropdown = ({ user, logoutUser }) => (
  <UncontrolledDropdown nav inNavbar>
    <span className="d-inline-block d-sm-none">
      <DropdownToggle nav caret>
        <Settings size={18} className="align-middle" />
      </DropdownToggle>
    </span>

    <span className="d-none d-sm-inline-block">
      <DropdownToggle nav caret>
        <img src={logo} className="avatar img-fluid rounded-circle mr-1" alt="user logo" />
        <span className="text-dark mr-2">{user.firstname_vch || "User"}</span>
      </DropdownToggle>
    </span>

    <DropdownMenu right>
      <DropdownItem tag={Link} to="/account/profile">
        <User size={18} className="align-middle mr-2" />
        Profile
      </DropdownItem>

      <DropdownItem divider />

      <DropdownItem tag={Link} to="/account/security">
        Security
      </DropdownItem>

      {/*<DropdownItem tag={Link} to="/account/help">*/}
      {/*  Help*/}
      {/*</DropdownItem>*/}

      <DropdownItem onClick={logoutUser}>Sign out</DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default NavBarAccountDropdown;
